import { render } from "./MobileFooter.vue?vue&type=template&id=577fe9f3&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&steup=true&lang=js"
export * from "./MobileFooter.vue?vue&type=script&steup=true&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=577fe9f3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577fe9f3"]])

export default __exports__